/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import { authHeaders, axiosInstance, downloadImage, formatRupiah, formatTime, isEmptyData, isInUvApp, postToUvApp, sendAnalyticsCustomEvent, sendAnalyticsPageView, trackMetaPixelEvent } from '../../utils/helper';
import Loader from '../../components/Loader/index';
import { ArrowLeftIcon, ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/solid';
import { ClockIcon } from '@heroicons/react/24/outline';
import { CopyIcon, DownloadIcon, InfoIcon, WaitingPaymentIcon } from '../../utils/svg';
import { formatDate } from '../../utils/helper';
import useToast from '../../components/Toast/index';
import { useDispatch, useSelector } from 'react-redux';
import { setPayment, clearPayment } from '../../store/reducers/payment';
import { clearCart } from '../../store/reducers/cart';
import { clearVoucher } from '../../store/reducers/voucher';
import { ListPaymentMethodAll } from '../../utils/constants';
import useNavigation from '../../hook/useNavigation';
import ImageLoader from '../../components/ImageLoader';

const Payment = () => {
  const navigate = useNavigation();
	const dispatch = useDispatch();

	const paymentData = useSelector((store) => store.payment);
	const [isLoadingCheckPayment, setIsLoadingCheckPayment] = useState(false);
	const [openIndex, setOpenIndex] = useState(null);
	const user = useSelector((store) => store?.user);

  const normalizedCompanyName = useMemo(() => {
    return user?.companyName?.toLowerCase().replace(/\s+/g, "") ?? "";
  }, [user?.companyName]);
	
  const isB2BBRI = user?.is_b2b === true && normalizedCompanyName === "bri";
  const isOneSmile = user?.is_b2b === true && normalizedCompanyName === "onesmile";
  const isUVApp = !user?.is_b2b; 

	const { showToast } = useToast();

	const toggleOpen = (index) => {
		setOpenIndex(openIndex === index ? null : index);
	};

  useEffect(() => {
    sendAnalyticsPageView("payment_pending_session");
  }, []);

  useEffect(() => {
    if (paymentData) {
      sendAnalyticsCustomEvent("payment", paymentData); 
      sendAnalyticsCustomEvent("payment", paymentData);
	  trackMetaPixelEvent("payment", paymentData);
    }
  }, []);

	const handleGetPaymentStatus = async (loading = false) => {
    console.log('handleGetPaymentStatus');
		try {
			loading && setIsLoadingCheckPayment(true);
			const data = new FormData();
			data.append('session_token', paymentData?.session_token);
			data.append('paymentReference', paymentData?.reference_no || null);
			const config = {
				headers: {
					'Content-Type': 'multipart/form-data',
          ...authHeaders().headers,
				},
			};

			const url = `status-payment`;
			const res = await axiosInstance.post(url, data, config);
			if (res?.data?.status?.toLowerCase() === 'ok' || res?.data?.status?.toLowerCase() === "success") {
				const result = res?.data?.data || {};
				if (result?.status?.toLowerCase() === 'success') {
					dispatch(clearCart());
					dispatch(clearPayment());
					dispatch(clearVoucher());
					navigate.push({
						pathname: '/payment/success',
						state: {
							payment: result,
						},
					});
				}
				if (result?.is_expired) {
          dispatch(
						setPayment({
							timeLeft: 0,
							status: 'EXPIRED',
						}),
					);
				}
			}
			loading && setIsLoadingCheckPayment(false);
		} catch (error) {
			console.log('error: ', error);
			setIsLoadingCheckPayment(false);
		}
	};

  const handleDownloadQris = async () => {
    console.log('handleDownloadQris');
	
	if (isInUvApp()) {
      postToUvApp({
        action: 'download_qris',
        image: paymentData?.qr_image_url,
      });
      return;
    }

    try {
      const name = `QRIS_${paymentData?.order_id || paymentData?.reference_no || Date.now()}`;
      await downloadImage(paymentData?.qr_image_url, name);
    } catch (error) {
      console.error('error: ', error);
      showToast('error', 'Gagal mengunduh gambar QRIS');
    }
  };

	useEffect(() => {
		if (!paymentData || paymentData?.status === 'EXPIRED') return;

		const interval = setInterval(() => {
			handleGetPaymentStatus();

			if (paymentData?.timeLeft > 0) {
				dispatch(
					setPayment({
						timeLeft: paymentData?.timeLeft - 1,
					}),
				);
			} else {
				clearInterval(interval);
        console.log('expired');
        dispatch(
					setPayment({
						timeLeft: 0,
            status: "EXPIRED"
					}),
				);
			}
		}, 5000);

		return () => clearInterval(interval);
	}, [paymentData, dispatch, showToast]);

	const copyToClipboard = (text) => {
		navigator.clipboard
			.writeText(text)
			.then(() => {
				showToast('info', 'copied');
			})
			.catch((err) => {
				console.error('Failed to copy: ', err);
			});
	};

  const paymentMethod = useMemo(() => {
    let payment = ListPaymentMethodAll?.find(
      (method) => method?.name?.toLocaleLowerCase() === paymentData?.payment_method?.toLocaleLowerCase()
    )
    if (isEmptyData(payment)) {
      payment = ListPaymentMethodAll?.find((method) => method?.code === paymentData?.payment_category?.payment_method?.[0]?.code)
    }
    return payment;
  }, [paymentData?.payment_method, paymentData?.payment_category, ListPaymentMethodAll]);

	return (
		<>
			{isLoadingCheckPayment && <Loader overlay />}
			<div className='h-screen w-full flex justify-center items-center bg-white'>
				<div className='relative h-screen w-full max-w-lg'>
					<div className={`absolute z-10 mt-5 w-full`}>
						<div className='flex flex-row justify-between mx-4'>
							<div className='flex justify-center items-center cursor-pointer' onClick={() => navigate.push('/')} id='payment_pending_back'>
								<ArrowLeftIcon className='h-8 w-8 text-gray-900 p-1.5' />
								<div className='pl-2 text-base text-gray-900 font-semibold truncate max-w-72'>Pembayaran</div>
							</div>
						</div>
						<div className='border-b-1 border-solid pb-2 border-gray-200' />
						<div className={`mx-4 mt-4`}>
							<div className='text-sm text-gray-900 font-semibold'>Detail Transaksi</div>
							<div className={`flex justify-between items-center mt-4`}>
								<div>
									<div className='text-xs text-gray-500 font-thin flex justify-start items-center'>Nomor Pesanan</div>
									<div className='text-xs text-gray-500 font-thin mt-2 flex justify-start items-center'>Waktu Pembelian</div>
									<div className='text-xs text-gray-500 font-thin mt-2 flex justify-start items-center'>Status</div>
								</div>
								<div>
									<div className='flex items-center justify-end gap-2'>
										<div className='text-xs text-gray-900 font-semibold'>{paymentData?.order_id || paymentData?.reference_no}</div>
										<div
											id='payment_pending_copy_order'
											onClick={() => {
												console.log('klik untuk menyalin nomor pesanan');
												copyToClipboard(paymentData?.order_id || paymentData?.reference_no);
											}}>
											<CopyIcon className='stroke-[var(--rose-violet)]' />
										</div>
									</div>
									<div className='text-xs text-gray-900 font-semibold mt-2 flex justify-end items-center'>{formatDate(paymentData?.date, 'D MMMM YYYY, HH:mm')}</div>
									<div className='text-xs text-star font-normal mt-2 flex justify-end items-center'>{['PENDING']?.includes(paymentData?.status) ? 'Menunggu Pembayaran' : paymentData?.status}</div>
								</div>
							</div>
						</div>
						<div className='mx-4 mt-8 mb-28'>
							<div className='mt-4 border-solid border-1 border-gray-300 rounded-lg px-4 py-2.5'>
								<div className={`flex justify-between`}>
									<div className={`flex`}>
										<WaitingPaymentIcon />
										<div className='pl-2'>
											<div className='text-gray-900 text-sm font-semibold'>Selesaikan pembayaran dalam</div>
											<div className='text-gray-500 text-xs font-normal pt-1'>{formatDate(paymentData?.expired_date, 'dddd, MMMM D, YYYY HH:mm')}</div>
										</div>
									</div>
									<div className='bg-red-100 flex h-5 items-center p-2 rounded-full'>
										<ClockIcon className='h-4 w-4 text-red-500' />
										<div className='text-xs font-semibold pl-1 text-red-500 tracking-wide'>{formatTime(paymentData?.timeLeft)}</div>
									</div>
								</div>
								<div className='border-b-1 border-solid pb-2 border-gray-300 mt-4' />
								<div className={`${!paymentMethod?.name?.toLocaleLowerCase().includes('qris') && 'hidden'}`}>
									<div className={`flex justify-between items-center mt-4`}>
										<div>
											<div className='bg-[var(--rose-violet-opacity)] px-4 py-2 rounded-md text-xs flex items-center gap-2 text-gray-600'>
												<InfoIcon className='h-7 w-auto' />
												{(isOneSmile || isUVApp) ? (
													<div>Silakan ambil tangkapan layar (screenshot) kode QRIS di bawah untuk melakukan pembayaran.</div>
												) : (
													<div>Anda dapat mengunduh atau mengambil tangkapan layar QRIS.</div>
												)}
											</div>
											<div className='h-72 flex justify-center items-center'>
												<ImageLoader src={paymentData?.qr_image_url} className={`w-64 h-auto object-contain object-center border-1 border-solid border-gray-400 rounded-lg`} />
											</div>
											<div className='flex justify-center items-center gap-2'>
												{(isOneSmile) ? '' : (
														<button
															id='payment_download_qris'
															className={`bg-[var(--rose-violet)] text-white border-[var(--rose-violet)] font-semibold text-sm p-3 items-center border-1 border-solid flex gap-2 justify-center`}
															onClick={() => {
																console.log('click download qris');
																handleDownloadQris();
															}}>
															<DownloadIcon className='h-4 w-auto' /> Download QRIS
														</button>	
												)}
											</div>
										</div>
									</div>
									<div className={`flex justify-between items-center mt-6`}>
										<div className='w-auto h-auto'>
											<ImageLoader src={paymentMethod?.image_url} className={`${paymentMethod?.image_size_payment || 'w-11'} h-auto object-contain object-center`} />
										</div>
									</div>
								</div>
								<div className={`flex justify-between items-center mt-4 ${paymentMethod?.name?.toLocaleLowerCase().includes('qris') && 'hidden'}`}>
									<div className='flex flex-col'>
										<div className='text-gray-500 text-xs font-normal'>Nomor Virtual Account</div>
										<div className='flex items-center pt-1'>
											<div className='text-gray-800 text-base font-bold'>{paymentData?.payment_generated || paymentData?.va_number}</div>
											<div
                        id='payment_pending_copy_va'
												className='pl-1'
												onClick={() => {
													console.log('copy va number');
													copyToClipboard(paymentData?.payment_generated || paymentData?.va_number);
												}}>
												<CopyIcon className="stroke-[var(--rose-violet)]" />
											</div>
										</div>
									</div>
									<div className='w-auto h-auto'>
                    <ImageLoader src={paymentMethod?.image_url} className={`${paymentMethod?.image_size_payment || 'w-11'} h-auto object-contain object-center`} />
									</div>
								</div>
								<div className={`flex flex-col mt-6`}>
									<div className='text-gray-900 text-xs font-normal'>Total Pembayaran</div>
									<div className='flex items-center pt-1'>
										<div className='text-gray-800 text-base font-bold'>{formatRupiah(Number(paymentData?.total_amount) || 0)}</div>
										<div
											id='payment_pending_copy_total'
											className='pl-1'
											onClick={() => {
												console.log('copy total amount');
												copyToClipboard(String(paymentData?.total_amount));
											}}>
											<CopyIcon className='stroke-[var(--rose-violet)]' />
										</div>
									</div>
								</div>
								<div className='border-b-1 border-solid pb-2 border-gray-300' />
								<div className='flex flex-col xs:flex-row xs:justify-between items-center mt-8 gap-2'>
									{isB2BBRI && paymentData?.redirect_url ? <>
										<button
											id='payment_pending_already_paid'
											disabled={!paymentData || paymentData?.status === 'EXPIRED'}
											className={`${
												!paymentData || paymentData?.status === 'EXPIRED'
													? 'bg-gray-300 text-white border-gray-300'
													: 'bg-[var(--rose-violet)] text-white border-[var(--rose-violet)]'
											} w-full font-semibold text-sm p-3 items-center border-1 border-solid`}
											onClick={() => {
												const redirectUrl = paymentData?.redirect_url;
												if (!redirectUrl) return;

												window.location.href = redirectUrl;
											}}>
											Bayar
										</button>
									</>:<>
										<button
											id='payment_pending_back_to_home'
											className={`bg-white text-[var(--rose-violet)] w-full font-semibold text-sm p-3 items-center border-1 border-solid border-[var(--rose-violet)]`}
											onClick={() => navigate.push('/')}>
											Beranda
										</button>
										<button
											id='payment_pending_already_paid'
											disabled={!paymentData || paymentData?.status === 'EXPIRED'}
											className={`${
												!paymentData || paymentData?.status === 'EXPIRED'
													? 'bg-gray-300 text-white border-gray-300'
													: 'bg-[var(--rose-violet)] text-white border-[var(--rose-violet)]'
											} w-full font-semibold text-sm p-3 items-center border-1 border-solid`}
											onClick={() => {
												console.log('click already paid');
												handleGetPaymentStatus(true);
											}}>
											Telah Dibayar
										</button>
									</>}
								</div>
							</div>
							<div className='mt-8'>
								<div className='text-gray-800 text-base font-bold'>Cara untuk melakukan pembayaran:</div>
								<div className='ml-4'>
									{paymentData?.payment_instructions?.map((instruction, index) => {
										const isOpen = openIndex === index;
										return (
											<div key={`instruction_${index}`}>
												<div className='flex justify-between items-center py-2 cursor-pointer' onClick={() => toggleOpen(index)}>
													<div className='text-gray-800 text-sm font-bold'>{instruction?.title ?? ''}</div>
													{isOpen ? <ChevronUpIcon className='h-4 w-4 text-gray-900' /> : <ChevronDownIcon className='h-4 w-4 text-gray-900' />}
												</div>
												{isOpen && (
													<div className='ml-2'>
														{instruction?.description.split('\n').map((line, idx) => (
															<p key={idx} className='text-gray-900 text-xs mb-1'>
																{line}
															</p>
														))}
													</div>
												)}
											</div>
										);
									})}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Payment;
